import { createStore, mapState } from 'vuex'
import Mutations from './mutations'

import { defineStore } from 'pinia'
import axios, { AxiosError } from 'axios'


export const useUserStore = defineStore('user', {
	state: () => {
		const userRecord: object | null = null
		const token: string = ""
		const isLoading: boolean = false
		const lastFetched: number | null = 0
		return {
			userRecord, token, isLoading, lastFetched
		}
	},
	getters: {
		// Add a getter to check if data is stale
		isDataStale: (state) => {
			if (!state.lastFetched) return true;
			// Consider data stale after 5 minutes
			return Date.now() - state.lastFetched > 5 * 60 * 1000;
		}
	},
	actions: {
		async initializeStore() {
			if (localStorage.getItem("userRecord") !== "undefined") {
				this.userRecord = JSON.parse(localStorage.getItem("userRecord")!)
				this.token = localStorage.getItem("token")!
				this.lastFetched = parseInt(localStorage.getItem("lastFetched") || "0")
				
				// If data is stale, refresh it
				if (this.isDataStale) {
					await this.refreshUserData()
				}
			}
		},
		
		// Method to refresh data from server
		async refreshUserData() {
			console.log("Refreshing user data")
			if (!this.token) return;
			
			this.isLoading = true;
			try {
				const response = await axios.post("/api/users/get/authorized",
					{ token: this.token },
					{ headers: { 'authorization': `Basic ${this.token}` }}
				);
				
				if (response.data.user) {
					console.log("Refreshed user data", response.data.user)
					this.userRecord = response.data.user;
					this.token = response.data.token;
					this.lastFetched = Date.now();
					this.updateLocalStorage();
				}
			} catch (err) {
				console.error("Failed to refresh user data:", err);
			} finally {
				this.isLoading = false;
			}
		},
		
		// Update local storage
		updateLocalStorage() {
			localStorage.setItem("userRecord", JSON.stringify(this.userRecord));
			localStorage.setItem("token", this.token);
			localStorage.setItem("lastFetched", this.lastFetched?.toString() || "0");
		},
		
		// Update user data after changes
		updateUserData(userData: any) {
			this.userRecord = userData;
			this.lastFetched = Date.now();
			this.updateLocalStorage();
		},

		clearSession() {
			this.userRecord = null
			this.token = ""
			this.lastFetched = 0
			localStorage.removeItem("userRecord")
			localStorage.removeItem("token")
			localStorage.removeItem("lastFetched")
			localStorage.removeItem("scopes")
		}
	}
})

